/** Custom DOM event name used to trigger annotation save from hotkeys */
export const MAE_SAVE_EVENT = 'mae-save-annotation';

/** Custom DOM event to delete the currently selected shape */
export const MAE_DELETE_SHAPE_EVENT = 'mae-delete-shape';

/** Dispatched by TargetSpatialInput when the last shape has been removed */
export const MAE_ANNOTATION_EMPTY_EVENT = 'mae-annotation-empty';
